module.exports = __webpack_public_path__ + "img/blockImgLanding-1310.ae718dd7.webp";